import { render, staticRenderFns } from "./my-upload.vue?vue&type=template&id=27370762&scoped=true"
import script from "./my-upload.vue?vue&type=script&lang=js"
export * from "./my-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27370762",
  null
  
)

export default component.exports